import * as currencies from '../../api/currencyApi';

const GET_CURRENCIES = 'efes/address/GET_CURRENCIES';
const GET_CURRENCIES_SUCCESS = 'efes/address/GET_CURRENCIES_SUCCESS';
const GET_CURRENCIES_FAIL = 'efes/address/GET_CURRENCIES_FAIL';

const initialState = {
  currencies: [],
  currencyLoading: false,
  error: null,
};

export default function reducer(state = initialState, action = {}) {
  switch (action.type) {
    case GET_CURRENCIES:
      return {
        ...state,
        currencyLoading: true,
      };
    case GET_CURRENCIES_SUCCESS:
      return {
        ...state,
        currencyLoading: false,
        currencies: action.result.currencies,
      };
    case GET_CURRENCIES_FAIL:
      return {
        ...state,
        currencyLoading: false,
        error: action.error,
      };
    default:
      return state;
  }
}

export function getCurrencies() {
  return {
    actions: [
      { type: GET_CURRENCIES },
      { type: GET_CURRENCIES_SUCCESS },
      { type: GET_CURRENCIES_FAIL, showError: true },
    ],
    promise: currencies.fetchCurrency().then((resp) => resp || []),
  };
}
